module.exports = require("clevertap-web-sdk");